var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoblanco(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 266.736,
    height: 149.409,
    viewBox: "0 0 266.736 149.409",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_52",
    "data-name": "Rect\\xE1ngulo 52",
    width: 112.025,
    height: 4.183,
    transform: "translate(0)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -21.771,
    y1: 705.025,
    x2: -21.754,
    y2: 705.025,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#209f37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.003,
    stopColor: "#229f36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.056,
    stopColor: "#44a72f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#5ead2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164,
    stopColor: "#71b226"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.221,
    stopColor: "#7db524"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#81b624"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.668,
    stopColor: "#b7c91c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#aac408"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#1c9f38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1c9f38"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_54",
    "data-name": "Rect\\xE1ngulo 54",
    width: 76.481,
    height: 4.183,
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -33.192,
    y1: 706.53,
    x2: -33.167,
    y2: 706.53,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#85468d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.053,
    stopColor: "#975897"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.126,
    stopColor: "#aa6ba1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.201,
    stopColor: "#b676a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#ba7aaa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.668,
    stopColor: "#bb4a8e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#8e488e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#cd006a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cd006a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_56",
    "data-name": "Rect\\xE1ngulo 56",
    width: 48.382,
    height: 4.183,
    transform: "translate(0)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -53.58,
    y1: 709.285,
    x2: -53.54,
    y2: 709.285,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1d66a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.033,
    stopColor: "#2a78b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.092,
    stopColor: "#3c92cb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#4aa5d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.214,
    stopColor: "#52b1e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#55b5e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.669,
    stopColor: "#4272b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.887,
    stopColor: "#81c0e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1e3c8a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_58",
    "data-name": "Rect\\xE1ngulo 58",
    width: 29.851,
    height: 4.183,
    transform: "translate(0)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -87.174,
    y1: 713.94,
    x2: -87.11,
    y2: 713.94,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ea8018"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.009,
    stopColor: "#ea8416"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.074,
    stopColor: "#f09e0c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.141,
    stopColor: "#f3b105"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.209,
    stopColor: "#f6bd01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#f7c100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.669,
    stopColor: "#ea8934"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#e26031"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dc312d"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8",
    "data-name": "Trazado 8",
    d: "M1345.372-217.66a3.3,3.3,0,0,0-1.006,1.067c-1.115,1.811-2.186,3.653-3.419,5.73l1.236-.157c3.76-.45,7.512-.981,11.277-1.32a10.354,10.354,0,0,0,7.6-5.969,16.391,16.391,0,0,0-6.9-1.272c-3.3,0-6.728.657-8.8,1.922",
    transform: "translate(-1340.947 219.582)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -120.331,
    y1: 353.609,
    x2: -120.236,
    y2: 353.609,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9",
    "data-name": "Trazado 9",
    d: "M1348.288-220.862c.368.121.473.2.552.174a34.162,34.162,0,0,1,15.48-1.351,1.167,1.167,0,0,0,.983-.312c1.558-2.476,3.058-4.992,4.795-7.853-.653-.04-1.293-.059-1.926-.059-7.991,0-14.384,3.208-19.884,9.4",
    transform: "translate(-1348.288 230.264)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -112.169,
    y1: 322.669,
    x2: -112.081,
    y2: 322.669,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10",
    "data-name": "Trazado 10",
    d: "M1350.818-222.736c-2.945.776-4.664,2.794-6.318,5.44.368.067.521.146.652.113a34.805,34.805,0,0,1,14.721-.634,1.188,1.188,0,0,0,.9-.138,22.144,22.144,0,0,0,4.766-5.92,14.983,14.983,0,0,0-3.635-.358,47.808,47.808,0,0,0-11.086,1.5",
    transform: "translate(-1344.5 224.233)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -115.694,
    y1: 436.121,
    x2: -115.603,
    y2: 436.121,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_11",
    "data-name": "Trazado 11",
    d: "M1341.5-211.765c-2.093,1.464-2.947,3.733-3.087,6.45,3.089-.738,5.952-1.495,8.84-2.093,3.448-.715,5.142-3.369,6.855-6.487a18.025,18.025,0,0,0-4.285-.548,14.155,14.155,0,0,0-8.323,2.677",
    transform: "translate(-1338.409 214.442)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -151.258,
    y1: 339.055,
    x2: -151.136,
    y2: 339.055,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12",
    "data-name": "Trazado 12",
    d: "M1365.376-248.963c-1.893,3.572-3.434,7.426-5.762,10.651-3.578,4.95-3.072,10.889-4.856,16.247a54.672,54.672,0,0,0,11.216-28.063c-.2.387-.395.78-.6,1.165",
    transform: "translate(-1354.758 250.128)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -207.647,
    y1: 114.088,
    x2: -207.476,
    y2: 114.088,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#066b30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.009,
    stopColor: "#0d6f2f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.061,
    stopColor: "#2f862e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.114,
    stopColor: "#49972e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.167,
    stopColor: "#5ca42d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.222,
    stopColor: "#68ab2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#6cae2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.668,
    stopColor: "#4fa732"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.997,
    stopColor: "#80b526"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80b526"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13",
    "data-name": "Trazado 13",
    d: "M1353.647-225.4a31.8,31.8,0,0,1,12.246-2.4,1.554,1.554,0,0,0,1.052-.78,19.791,19.791,0,0,0,2.236-8.756,40.026,40.026,0,0,0-15.534,11.931",
    transform: "translate(-1353.647 237.336)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: -154.575,
    y1: 263.143,
    x2: -154.451,
    y2: 263.143,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14",
    "data-name": "Trazado 14",
    d: "M1337.871-202.856a18.452,18.452,0,0,0,.094,9.453c3.246-5.151,6.4-10.158,9.578-15.208a1.234,1.234,0,0,0-.406-.19,8.4,8.4,0,0,0-2.14-.287c-3.43,0-6.184,2.33-7.125,6.232",
    transform: "translate(-1337.303 209.088)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -134.841,
    y1: 263.185,
    x2: -134.726,
    y2: 263.185,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15",
    "data-name": "Trazado 15",
    d: "M1349.827-231.9c-.32,2.179-.617,4.367-1.094,6.514-.654,2.963-1.466,5.891-2.309,9.229,6.088-2.072,9.032-15.758,7.136-20.229-1.364,1.43-3.386,2.119-3.733,4.486",
    transform: "translate(-1346.423 236.389)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: -242.64,
    y1: 160.016,
    x2: -242.428,
    y2: 160.016,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16",
    "data-name": "Trazado 16",
    d: "M1336.668-193.838a.857.857,0,0,0,.416-.544c1.269-6.027,2.61-12.042,3.754-18.094a11.8,11.8,0,0,0-1.209-7.608,51.412,51.412,0,0,0-2.961,26.246",
    transform: "translate(-1336.093 220.084)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: -326.655,
    y1: 126.343,
    x2: -326.335,
    y2: 126.343,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_17",
    "data-name": "Trazado 17",
    d: "M1339.858-220.483a3.562,3.562,0,0,0-.268,2.244,36.747,36.747,0,0,1,.69,12.623c3.546-3.037,6.014-17.375,3.659-22.045-1.458,2.537-2.842,4.818-4.08,7.179",
    transform: "translate(-1339.515 227.662)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: -292.434,
    y1: 150.007,
    x2: -292.154,
    y2: 150.007,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_18",
    "data-name": "Trazado 18",
    d: "M1346.958-230.8a5.943,5.943,0,0,0-2.284,5.571,20.1,20.1,0,0,1-.186,4.7c-.337,2.949-.788,5.887-1.2,8.852,3.785-2.049,7.748-14.564,5.245-20.61-.54.51-1.042,1.018-1.577,1.485",
    transform: "translate(-1343.29 232.283)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: -268.099,
    y1: 159.335,
    x2: -267.852,
    y2: 159.335,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19",
    "data-name": "Trazado 19",
    d: "M1357.334-226.892c.034.1.071.207.1.31q4.245-3.633,8.48-7.28a1.244,1.244,0,0,0,.356-.738,45.428,45.428,0,0,0-.5-11.908c-2.83,6.581-5.634,13.1-8.436,19.616",
    transform: "translate(-1357.334 246.508)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: -242.44,
    y1: 161.874,
    x2: -242.236,
    y2: 161.874,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20",
    "data-name": "Trazado 20",
    d: "M1353.365-236.951a2.07,2.07,0,0,0-.519,1.142c-.583,4.739-1.132,9.482-1.69,14.208a11.45,11.45,0,0,0,4.315-6.117c.579-2.415,1.108-4.846,1.5-7.3.276-1.713.287-3.463.452-5.642-1.625,1.472-2.871,2.554-4.059,3.7",
    transform: "translate(-1351.156 240.655)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: -336.79,
    y1: 172.688,
    x2: -336.484,
    y2: 172.688,
    xlinkHref: "#linear-gradient-2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4529",
    "data-name": "Grupo 4529",
    transform: "translate(-3684.825 1179.909)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_138",
    "data-name": "Trazado 138",
    d: "M1286.747-197.233h7.939l11.27,18.424h.074v-18.424h5.841v26.511h-7.639l-11.571-18.872h-.075v18.872h-5.841Z",
    transform: "translate(2398.218 -881.312)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_139",
    "data-name": "Trazado 139",
    d: "M1301.928-183.655a14.989,14.989,0,0,1,1.069-5.766,12.656,12.656,0,0,1,2.976-4.4,13.138,13.138,0,0,1,4.53-2.79,16.363,16.363,0,0,1,5.73-.973,16.359,16.359,0,0,1,5.728.973,13.133,13.133,0,0,1,4.53,2.79,12.654,12.654,0,0,1,2.978,4.4,14.98,14.98,0,0,1,1.067,5.766,14.979,14.979,0,0,1-1.067,5.766,12.653,12.653,0,0,1-2.978,4.4,13.105,13.105,0,0,1-4.53,2.79,16.359,16.359,0,0,1-5.728.973,16.364,16.364,0,0,1-5.73-.973,13.11,13.11,0,0,1-4.53-2.79,12.656,12.656,0,0,1-2.976-4.4,14.988,14.988,0,0,1-1.069-5.766m6.067,0a9.718,9.718,0,0,0,.58,3.426,7.827,7.827,0,0,0,1.665,2.694,7.621,7.621,0,0,0,2.6,1.78,8.7,8.7,0,0,0,3.39.636,8.689,8.689,0,0,0,3.388-.636,7.6,7.6,0,0,0,2.6-1.78,7.821,7.821,0,0,0,1.665-2.694,9.68,9.68,0,0,0,.583-3.426,9.725,9.725,0,0,0-.583-3.407,7.822,7.822,0,0,0-1.665-2.715,7.626,7.626,0,0,0-2.6-1.778,8.689,8.689,0,0,0-3.388-.636,8.7,8.7,0,0,0-3.39.636,7.643,7.643,0,0,0-2.6,1.778,7.828,7.828,0,0,0-1.665,2.715,9.763,9.763,0,0,0-.58,3.407",
    transform: "translate(2412.13 -881.634)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_140",
    "data-name": "Trazado 140",
    d: "M1317.56-197.233h6.665l6.552,17.374h.077l6.665-17.374h6.253l-10.935,26.511h-4.68Z",
    transform: "translate(2426.454 -881.312)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_141",
    "data-name": "Trazado 141",
    d: "M1341.641-197.233h4.829L1358-170.723h-6.59l-2.284-5.617h-10.3l-2.21,5.617h-6.439Zm2.246,7.713-3.219,8.236h6.477Z",
    transform: "translate(2438.021 -881.311)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_142",
    "data-name": "Trazado 142",
    d: "M1364.105-190.021a5.75,5.75,0,0,0-2.115-1.61,7.028,7.028,0,0,0-2.9-.561,7.311,7.311,0,0,0-3.051.636,7.307,7.307,0,0,0-2.434,1.778,8.3,8.3,0,0,0-1.609,2.715,9.755,9.755,0,0,0-.581,3.407,9.7,9.7,0,0,0,.581,3.424,8.525,8.525,0,0,0,1.59,2.7,7.21,7.21,0,0,0,2.378,1.78,6.886,6.886,0,0,0,2.939.636,6.607,6.607,0,0,0,3.183-.749,6.339,6.339,0,0,0,2.282-2.1l4.869,3.631a10.118,10.118,0,0,1-4.269,3.482,13.2,13.2,0,0,1-5.316,1.125,16.363,16.363,0,0,1-5.73-.973,13.111,13.111,0,0,1-4.53-2.79,12.648,12.648,0,0,1-2.976-4.4,14.954,14.954,0,0,1-1.069-5.766,14.964,14.964,0,0,1,1.069-5.768,12.64,12.64,0,0,1,2.976-4.4,13.11,13.11,0,0,1,4.53-2.79,16.363,16.363,0,0,1,5.73-.973,13.97,13.97,0,0,1,2.34.207,12.589,12.589,0,0,1,2.4.653,10.906,10.906,0,0,1,2.267,1.2,9.219,9.219,0,0,1,1.947,1.836Z",
    transform: "translate(2451.913 -881.634)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_143",
    "data-name": "Trazado 143",
    d: "M1359.59-197.233h18.01v5.393h-12.169v4.942h11.5v5.392h-11.5v5.393h12.843v5.391H1359.59Z",
    transform: "translate(2464.967 -881.312)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_144",
    "data-name": "Trazado 144",
    d: "M1371.782-197.233h7.939l11.268,18.424h.077v-18.424h5.839v26.511h-7.637L1377.7-189.595h-.075v18.872h-5.841Z",
    transform: "translate(2476.139 -881.312)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_145",
    "data-name": "Trazado 145",
    d: "M1394-192.065h-7.564v-5.168H1407.4v5.168h-7.562v21.342H1394Z",
    transform: "translate(2489.567 -881.312)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_146",
    "data-name": "Trazado 146",
    d: "M1398.921-197.233h10.26a18.085,18.085,0,0,1,3.838.393,9.152,9.152,0,0,1,3.183,1.311,6.563,6.563,0,0,1,2.171,2.472,8.363,8.363,0,0,1,.8,3.875,7.778,7.778,0,0,1-1.458,4.774,6.581,6.581,0,0,1-4.27,2.491l6.74,11.2h-7l-5.54-10.6h-2.884v10.6h-5.841Zm5.841,10.971h3.446c.523,0,1.077-.019,1.666-.056a5.217,5.217,0,0,0,1.59-.337,2.763,2.763,0,0,0,1.181-.88,2.693,2.693,0,0,0,.468-1.684,2.82,2.82,0,0,0-.41-1.612,2.777,2.777,0,0,0-1.051-.916,4.633,4.633,0,0,0-1.46-.431,11.914,11.914,0,0,0-1.61-.113h-3.819Z",
    transform: "translate(2501.007 -881.311)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_147",
    "data-name": "Trazado 147",
    d: "M1410.841-183.655a14.98,14.98,0,0,1,1.068-5.766,12.647,12.647,0,0,1,2.974-4.4,13.155,13.155,0,0,1,4.534-2.79,16.353,16.353,0,0,1,5.728-.973,16.358,16.358,0,0,1,5.728.973,13.134,13.134,0,0,1,4.53,2.79,12.654,12.654,0,0,1,2.978,4.4,14.986,14.986,0,0,1,1.068,5.766,14.986,14.986,0,0,1-1.068,5.766,12.654,12.654,0,0,1-2.978,4.4,13.106,13.106,0,0,1-4.53,2.79,16.358,16.358,0,0,1-5.728.973,16.353,16.353,0,0,1-5.728-.973,13.127,13.127,0,0,1-4.534-2.79,12.647,12.647,0,0,1-2.974-4.4,14.979,14.979,0,0,1-1.068-5.766m6.065,0a9.721,9.721,0,0,0,.581,3.426,7.852,7.852,0,0,0,1.665,2.694,7.624,7.624,0,0,0,2.6,1.78,8.7,8.7,0,0,0,3.39.636,8.692,8.692,0,0,0,3.388-.636,7.6,7.6,0,0,0,2.6-1.78,7.8,7.8,0,0,0,1.665-2.694,9.724,9.724,0,0,0,.582-3.426,9.769,9.769,0,0,0-.582-3.407,7.8,7.8,0,0,0-1.665-2.715,7.626,7.626,0,0,0-2.6-1.778,8.692,8.692,0,0,0-3.388-.636,8.7,8.7,0,0,0-3.39.636,7.646,7.646,0,0,0-2.6,1.778,7.854,7.854,0,0,0-1.665,2.715,9.766,9.766,0,0,0-.581,3.407",
    transform: "translate(2511.93 -881.634)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_148",
    "data-name": "Trazado 148",
    d: "M1301.59-177.874h3.754a4.388,4.388,0,0,1,1.688.28,2.864,2.864,0,0,1,1.048.709,2.392,2.392,0,0,1,.535.964,3.769,3.769,0,0,1,.151,1.033,3.77,3.77,0,0,1-.151,1.033,2.413,2.413,0,0,1-.535.966,2.884,2.884,0,0,1-1.048.707,4.388,4.388,0,0,1-1.688.28h-2.307v4.7h-1.447Zm1.447,4.7h1.9a5.3,5.3,0,0,0,.835-.067,2.275,2.275,0,0,0,.74-.249,1.357,1.357,0,0,0,.519-.521,1.75,1.75,0,0,0,.2-.881,1.75,1.75,0,0,0-.2-.882,1.339,1.339,0,0,0-.519-.519,2.189,2.189,0,0,0-.74-.249,5.078,5.078,0,0,0-.835-.069h-1.9Z",
    transform: "translate(2411.82 -863.572)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_149",
    "data-name": "Trazado 149",
    d: "M1312.438-177.874h1.313l4.568,10.676h-1.688l-1.071-2.639h-5.08l-1.056,2.639h-1.688Zm2.595,6.77-1.991-4.9h-.029l-2.022,4.9Z",
    transform: "translate(2417.45 -863.572)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_150",
    "data-name": "Trazado 150",
    d: "M1316.9-169.3a2.387,2.387,0,0,0,1,.868,3.006,3.006,0,0,0,1.259.278,2.524,2.524,0,0,0,.74-.113,2.273,2.273,0,0,0,.686-.339,1.9,1.9,0,0,0,.506-.558,1.5,1.5,0,0,0,.2-.77,1.155,1.155,0,0,0-.393-.941,3.377,3.377,0,0,0-.971-.542c-.389-.148-.811-.287-1.267-.424a5.079,5.079,0,0,1-1.267-.565,3.1,3.1,0,0,1-.973-.972,3.04,3.04,0,0,1-.393-1.652,2.774,2.774,0,0,1,.2-.995,2.814,2.814,0,0,1,.64-.966,3.537,3.537,0,0,1,1.123-.73,4.16,4.16,0,0,1,1.652-.293,5.753,5.753,0,0,1,1.673.241,2.873,2.873,0,0,1,1.4.977l-1.177,1.071a1.939,1.939,0,0,0-.768-.678,2.437,2.437,0,0,0-1.13-.257,2.739,2.739,0,0,0-1,.159,1.8,1.8,0,0,0-.642.408,1.419,1.419,0,0,0-.339.535,1.642,1.642,0,0,0-.1.527,1.346,1.346,0,0,0,.393,1.041,3.037,3.037,0,0,0,.971.588,12.036,12.036,0,0,0,1.267.406,5.483,5.483,0,0,1,1.267.506,2.975,2.975,0,0,1,.974.874,2.586,2.586,0,0,1,.391,1.516,3.194,3.194,0,0,1-.294,1.387,3.1,3.1,0,0,1-.791,1.041,3.517,3.517,0,0,1-1.177.648,4.529,4.529,0,0,1-1.447.226,5.289,5.289,0,0,1-1.945-.36,3.2,3.2,0,0,1-1.464-1.117Z",
    transform: "translate(2424.76 -863.701)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_151",
    "data-name": "Trazado 151",
    d: "M1326.728-177.874h1.313l4.567,10.676h-1.688l-1.071-2.639h-5.08l-1.056,2.639h-1.688Zm2.593,6.77-1.991-4.9h-.029l-2.02,4.9Z",
    transform: "translate(2430.543 -863.572)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_152",
    "data-name": "Trazado 152",
    d: "M1334.381-177.874h1.447v7.629a3.735,3.735,0,0,1-.316,1.652,2.876,2.876,0,0,1-.791,1.01,2.837,2.837,0,0,1-1.018.512,3.92,3.92,0,0,1-1,.144,3.093,3.093,0,0,1-1.906-.581,2.676,2.676,0,0,1-.987-1.757l1.416-.316a1.709,1.709,0,0,0,.5.951,1.4,1.4,0,0,0,.979.347,1.582,1.582,0,0,0,.868-.211,1.476,1.476,0,0,0,.506-.552,2.29,2.29,0,0,0,.24-.776,6.469,6.469,0,0,0,.062-.889Z",
    transform: "translate(2437.681 -863.572)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_153",
    "data-name": "Trazado 153",
    d: "M1336.437-177.874h6.891v1.357h-5.444v3.181h5.067v1.357h-5.067v3.423h5.714v1.357h-7.161Z",
    transform: "translate(2443.751 -863.572)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_154",
    "data-name": "Trazado 154",
    d: "M1355.557-175.438a2.963,2.963,0,0,0-1.146-.9,3.386,3.386,0,0,0-1.432-.318,3.842,3.842,0,0,0-1.637.341,3.766,3.766,0,0,0-1.251.926,4.257,4.257,0,0,0-.807,1.38,4.945,4.945,0,0,0-.286,1.7,4.7,4.7,0,0,0,.271,1.6,3.98,3.98,0,0,0,.784,1.328,3.686,3.686,0,0,0,1.251.9,4.028,4.028,0,0,0,1.675.332,3.334,3.334,0,0,0,1.614-.376,3.486,3.486,0,0,0,1.175-1.056l1.223.92a5.232,5.232,0,0,1-.424.475,4.249,4.249,0,0,1-.8.617,5.69,5.69,0,0,1-1.2.542,5.089,5.089,0,0,1-1.621.234,5.261,5.261,0,0,1-2.284-.483,5.509,5.509,0,0,1-1.734-1.265,5.526,5.526,0,0,1-1.092-1.773,5.52,5.52,0,0,1-.378-2,6.278,6.278,0,0,1,.406-2.284,5.37,5.37,0,0,1,1.14-1.809,5.077,5.077,0,0,1,1.755-1.184,5.882,5.882,0,0,1,2.261-.422,5.563,5.563,0,0,1,2.073.406,3.863,3.863,0,0,1,1.665,1.251Z",
    transform: "translate(2453.852 -863.701)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_155",
    "data-name": "Trazado 155",
    d: "M1360.75-166.8a5.77,5.77,0,0,1-2.246-.429,5.263,5.263,0,0,1-1.757-1.184,5.479,5.479,0,0,1-1.146-1.778,5.873,5.873,0,0,1-.414-2.217,5.863,5.863,0,0,1,.414-2.215,5.467,5.467,0,0,1,1.146-1.78,5.263,5.263,0,0,1,1.757-1.184,5.771,5.771,0,0,1,2.246-.429,5.769,5.769,0,0,1,2.246.429,5.241,5.241,0,0,1,1.757,1.184,5.5,5.5,0,0,1,1.148,1.78,5.89,5.89,0,0,1,.412,2.215,5.9,5.9,0,0,1-.412,2.217,5.517,5.517,0,0,1-1.148,1.778,5.24,5.24,0,0,1-1.757,1.184,5.768,5.768,0,0,1-2.246.429m0-1.357a3.931,3.931,0,0,0,1.658-.339,3.925,3.925,0,0,0,1.267-.912,4,4,0,0,0,.815-1.349,4.722,4.722,0,0,0,.287-1.652,4.73,4.73,0,0,0-.287-1.652,4,4,0,0,0-.815-1.349,3.924,3.924,0,0,0-1.267-.912,3.96,3.96,0,0,0-1.658-.339,3.955,3.955,0,0,0-1.658.339,3.928,3.928,0,0,0-1.267.912,4,4,0,0,0-.814,1.349,4.728,4.728,0,0,0-.287,1.652,4.72,4.72,0,0,0,.287,1.652,4,4,0,0,0,.814,1.349,3.929,3.929,0,0,0,1.267.912,3.926,3.926,0,0,0,1.658.339",
    transform: "translate(2460.933 -863.702)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_156",
    "data-name": "Trazado 156",
    d: "M1364.211-177.874h2.156l3.394,8.081h.061l3.361-8.081h2.156V-167.2h-1.447v-8.775h-.031l-3.6,8.775h-.964l-3.6-8.775h-.029v8.775h-1.449Z",
    transform: "translate(2469.201 -863.572)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_157",
    "data-name": "Trazado 157",
    d: "M1373.582-177.874h6.891v1.357h-5.442v3.181h5.065v1.357h-5.065v3.423h5.712v1.357h-7.161Z",
    transform: "translate(2477.788 -863.572)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_158",
    "data-name": "Trazado 158",
    d: "M1380.577-177.874h3.754a4.4,4.4,0,0,1,1.69.28,2.852,2.852,0,0,1,1.046.709,2.392,2.392,0,0,1,.537.964,3.836,3.836,0,0,1,.15,1.033,2.743,2.743,0,0,1-.18.987,2.823,2.823,0,0,1-.519.86,2.989,2.989,0,0,1-.832.648,2.866,2.866,0,0,1-1.092.324l3.032,4.871h-1.809l-2.713-4.7h-1.615v4.7h-1.447Zm1.447,4.7h1.9a5.329,5.329,0,0,0,.837-.067,2.266,2.266,0,0,0,.738-.249,1.349,1.349,0,0,0,.521-.521,1.772,1.772,0,0,0,.2-.881,1.773,1.773,0,0,0-.2-.882,1.331,1.331,0,0,0-.521-.519,2.179,2.179,0,0,0-.738-.249,5.108,5.108,0,0,0-.837-.069h-1.9Z",
    transform: "translate(2484.198 -863.572)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_159",
    "data-name": "Trazado 159",
    d: "M1395.323-175.438a2.972,2.972,0,0,0-1.146-.9,3.4,3.4,0,0,0-1.434-.318,3.838,3.838,0,0,0-1.635.341,3.772,3.772,0,0,0-1.253.926,4.258,4.258,0,0,0-.8,1.38,4.946,4.946,0,0,0-.287,1.7,4.694,4.694,0,0,0,.272,1.6,3.954,3.954,0,0,0,.784,1.328,3.686,3.686,0,0,0,1.252.9,4.024,4.024,0,0,0,1.673.332,3.323,3.323,0,0,0,1.614-.376,3.494,3.494,0,0,0,1.177-1.056l1.221.92a5.151,5.151,0,0,1-.422.475,4.266,4.266,0,0,1-.8.617,5.655,5.655,0,0,1-1.2.542,5.084,5.084,0,0,1-1.619.234,5.277,5.277,0,0,1-2.286-.483,5.525,5.525,0,0,1-1.732-1.265,5.522,5.522,0,0,1-1.093-1.773,5.53,5.53,0,0,1-.379-2,6.276,6.276,0,0,1,.408-2.284,5.4,5.4,0,0,1,1.138-1.809,5.1,5.1,0,0,1,1.757-1.184,5.874,5.874,0,0,1,2.261-.422,5.563,5.563,0,0,1,2.073.406,3.877,3.877,0,0,1,1.665,1.251Z",
    transform: "translate(2490.29 -863.701)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_50",
    "data-name": "Rect\\xE1ngulo 50",
    width: 1.447,
    height: 10.674,
    transform: "translate(3892.986 -1041.447)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_160",
    "data-name": "Trazado 160",
    d: "M1403.667-177.874h1.313l4.569,10.676h-1.688l-1.072-2.639h-5.08l-1.056,2.639h-1.688Zm2.595,6.77-1.991-4.9h-.031l-2.018,4.9Z",
    transform: "translate(2501.048 -863.572)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_161",
    "data-name": "Trazado 161",
    d: "M1407.4-177.874h1.449v9.317h4.9v1.357H1407.4Z",
    transform: "translate(2508.776 -863.572)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_116",
    "data-name": "Grupo 116",
    transform: "translate(3684.825 -1049.334)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_51",
    "data-name": "Rect\\xE1ngulo 51",
    width: 112.025,
    height: 4.183,
    transform: "translate(0)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_117",
    "data-name": "Grupo 117",
    transform: "translate(3796.85 -1049.334)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_53",
    "data-name": "Rect\\xE1ngulo 53",
    width: 76.481,
    height: 4.183,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_118",
    "data-name": "Grupo 118",
    transform: "translate(3873.329 -1049.334)",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_55",
    "data-name": "Rect\\xE1ngulo 55",
    width: 48.382,
    height: 4.183,
    transform: "translate(0)",
    fill: "url(#linear-gradient-3)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_119",
    "data-name": "Grupo 119",
    transform: "translate(3921.71 -1049.334)",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_57",
    "data-name": "Rect\\xE1ngulo 57",
    width: 29.851,
    height: 4.183,
    transform: "translate(0)",
    fill: "url(#linear-gradient-4)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_120",
    "data-name": "Grupo 120",
    transform: "translate(3779.529 -1179.909)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5",
    "data-name": "Trazado 5",
    d: "M1395.31-240.022h-17.584v46.279c-5.17-6.3-10.425-13.271-15.2-19.089a41.335,41.335,0,0,1-4.254,6.883,35.172,35.172,0,0,1-6.607,7.069c9.5,11.573,18.9,23.029,28.325,34.461a2.444,2.444,0,0,0,1.5.958c4.576.077,9.152.046,13.817.046Z",
    transform: "translate(-1321.822 259.388)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6",
    "data-name": "Trazado 6",
    d: "M1395.31-240.022h-17.584v46.279c-5.17-6.3-10.425-13.271-15.2-19.089a41.335,41.335,0,0,1-4.254,6.883,35.172,35.172,0,0,1-6.607,7.069c9.5,11.573,18.9,23.029,28.325,34.461a2.444,2.444,0,0,0,1.5.958c4.576.077,9.152.046,13.817.046Z",
    transform: "translate(-1321.822 259.388)",
    fill: "none",
    stroke: "#1d1d1b",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7",
    "data-name": "Trazado 7",
    d: "M1337.795-203.3v-36.786c4.7,0,9.357-.034,14.01.046.5.008,1.075.6,1.456,1.044,1.805,2.133,4.212,4.076,6.228,6.539a80.522,80.522,0,0,0-13.709,14.528c-2.781,3.6-6.809,10.2-7.986,14.629",
    transform: "translate(-1334.533 259.322)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_28",
    "data-name": "Grupo 28",
    transform: "translate(9.302 58.536)",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_14",
    "data-name": "Rect\\xE1ngulo 14",
    width: 20.118,
    height: 8.719,
    transform: "translate(0 -0.001)",
    fill: "url(#linear-gradient-5)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_30",
    "data-name": "Grupo 30",
    transform: "translate(23.368 38.066)",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_15",
    "data-name": "Rect\\xE1ngulo 15",
    width: 21.81,
    height: 9.601,
    transform: "translate(0.001 0)",
    fill: "url(#linear-gradient-6)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_32",
    "data-name": "Grupo 32",
    transform: "translate(16.111 49.623)",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_16",
    "data-name": "Rect\\xE1ngulo 16",
    width: 21.039,
    height: 7.083,
    transform: "translate(0.001 0)",
    fill: "url(#linear-gradient-7)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_34",
    "data-name": "Grupo 34",
    transform: "translate(4.439 68.386)",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_17",
    "data-name": "Rect\\xE1ngulo 17",
    width: 15.695,
    height: 9.127,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-8)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_36",
    "data-name": "Grupo 36",
    transform: "translate(35.769)",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_18",
    "data-name": "Rect\\xE1ngulo 18",
    width: 11.216,
    height: 28.063,
    transform: "translate(0 -0.001)",
    fill: "url(#linear-gradient-9)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_38",
    "data-name": "Grupo 38",
    transform: "translate(33.64 24.514)",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_19",
    "data-name": "Rect\\xE1ngulo 19",
    width: 15.534,
    height: 11.931,
    transform: "translate(0.001 0)",
    fill: "url(#linear-gradient-10)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_40",
    "data-name": "Grupo 40",
    transform: "translate(2.318 78.646)",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_20",
    "data-name": "Rect\\xE1ngulo 20",
    width: 16.707,
    height: 12.1,
    transform: "translate(-1.868 15.51) rotate(-83.936)",
    fill: "url(#linear-gradient-11)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_42",
    "data-name": "Grupo 42",
    transform: "translate(19.796 26.328)",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_21",
    "data-name": "Rect\\xE1ngulo 21",
    width: 9.032,
    height: 20.229,
    transform: "translate(0.001 -0.001)",
    fill: "url(#linear-gradient-12)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_44",
    "data-name": "Grupo 44",
    transform: "translate(0 57.574)",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22",
    "data-name": "Rect\\xE1ngulo 22",
    width: 5.979,
    height: 26.246,
    transform: "translate(-0.769 0)",
    fill: "url(#linear-gradient-13)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_46",
    "data-name": "Grupo 46",
    transform: "translate(6.559 43.052)",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_23",
    "data-name": "Rect\\xE1ngulo 23",
    width: 6.862,
    height: 22.046,
    transform: "translate(-0.084 0)",
    fill: "url(#linear-gradient-14)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_48",
    "data-name": "Grupo 48",
    transform: "translate(13.792 34.197)",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_24",
    "data-name": "Rect\\xE1ngulo 24",
    width: 7.748,
    height: 20.61,
    transform: "translate(0.001 0)",
    fill: "url(#linear-gradient-15)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_50",
    "data-name": "Grupo 50",
    transform: "translate(40.705 6.937)",
    clipPath: "url(#clip-path-16)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_25",
    "data-name": "Rect\\xE1ngulo 25",
    width: 9.377,
    height: 19.926,
    transform: "translate(0.001 0)",
    fill: "url(#linear-gradient-16)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_52",
    "data-name": "Grupo 52",
    transform: "translate(28.866 18.153)",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_26",
    "data-name": "Rect\\xE1ngulo 26",
    width: 6.268,
    height: 19.054,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-17)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_45",
    "data-name": "Trazado 45",
    d: "M1355.956-214.064l-.2,26.8h-17.927l9.064-14.165",
    transform: "translate(-1334.504 283.175)",
    fill: "#1d1d1b"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoblanco);
export default __webpack_public_path__ + "static/media/logoblanco.9fae46a7d9a8b8d4f55e21cb7109fba2.svg";
export { ForwardRef as ReactComponent };